import React, { useMemo } from 'react';
import { BaseNav } from './base-nav.component';
import { useNav } from '../../nav.context';
import { featureEnabled } from 'feature-toggles!sofe'

export const TemplatesNav = () => {
  const nav = useNav();
  const navLinks = useMemo(() => {

    return [
      {
        label: 'Task',
        url: 'templates/tasks',
        enabled: nav.user.permissions['tasks_generic'],
      },
      {
        label: 'Folder',
        url: 'files/global-settings/folder-templates',
        enabled: !featureEnabled('toggle_disable_new_folders_dm') ? nav.user.permissions['templates_folders'] : nav.user.permissions['templates_folders', 'files_add_folder'],
      },
      {
        label: 'Email',
        url: 'communications/global-settings/templates',
        enabled: nav.user.permissions.communications,
      },
      {
        label: 'Letter',
        url: 'letters/global-settings/templates',
        enabled: nav.user.permissions['templates_letters'],
      },
      {
        label: 'Client Request',
        url: 'templates/client-requests',
        enabled: nav.user.permissions['templates_client_requests'],
      },
      {
        label: 'Boilerplate Letter Text',
        url: 'letters/global-settings/boilerplate',
        enabled: nav.user.permissions['templates_boilerplate_text'],
      },
      {
        label: 'Client Portal Invitation',
        url: 'notifications/global-settings/messages',
        enabled: nav.user.permissions['templates_invitations'],
      },
      {
        label: 'Tax Resolution Engagement',
        url: 'admin/global-settings/service-templates/',
        enabled: nav.user.permissions['templates_tax_resolution_engagements'],
      },
      {
        label: 'Notice',
        url: 'notices/global-settings',
        enabled: nav.user.permissions['templates_notices'],
      },
    ];
  }, [nav.user]);

  return <BaseNav title="Templates" nav={nav} navLinks={navLinks} />;
};
